import PIXI from 'pixi.js/src';

const textureHelper = {
  /**
   * Loads the initial images
   * @param {Array<String>} images - An array of image paths
   * @param {Function} callback - A callback to fire when the images are loaded
   * loaded
   * @returns {undefined} undefined
   */
  preloadTextures(images, callback) {
    for (let i = 0; i < images.length; i++) {
      PIXI.loader.add(images[i]);
    }

    PIXI.loader.load(() => {
      callback('textures', true);
    });
  },
};

export default textureHelper;



/** WEBPACK FOOTER **
 ** ./assets/js/src/helpers/texture.js
 **/